import { ROLE } from './acl$';
import { CoordinatorService } from './coordinator.service';
import { Temporal } from '@js-temporal/polyfill';
import { COLNAME, QF } from './firebase-firestore';
import { DocumentReference } from 'firebase/firestore';
import { User } from './user';

export class ProjectInList {
    id: string;
    isFirstRun = false;
    private _title = '';

    description?: string;
    isPending: boolean;
    isLoading?: boolean;
    role: ROLE;

    tagLs: string[] = [];

    team: any[] = [];
    // lastUpdate?: Temporal.ZonedDateTime
    lastOpen?: Temporal.ZonedDateTime;
    created: number;

    openAs?: 'editor' | 'viewer';
    scriptLs?: string[];

    private _isCloud = false;

    private _invitationData: undefined | { hostId: string; created: Temporal.ZonedDateTime };

    constructor(
        private coords: CoordinatorService,
        params: {
            id: string;
            title?: string;
            description?: string;
            isCloud?: boolean;
            isPending?: boolean;
            isLoading?: boolean;
            tagLs?: string[];
            role?: ROLE;
            created?: number;
            lastUpdate?: string;
            lastOpen?: string | Temporal.Instant;
            cloudInfo?: any;
        },
    ) {
        this.id = params.id;
        this._isCloud = params.isCloud || false;

        this.role = params.role || 'owner';
        this.isPending = params.isPending || false;
        this.tagLs = params.tagLs || [];

        this.openAs = params.cloudInfo?.openAs;
        this.scriptLs = params.cloudInfo?.scriptLs;

        // console.log(params);
        // console.log(this.title, this.scriptLs);

        if (!this.isCloud) {
            this._title = params.title || '';
            this.description = params.description || '';
            this.isLoading = params.isLoading || false;
            this._finalizeDateTime(params);
        }

        // if (this.isPending) {
        //     console.log('WWW', params, this._invitationData?.created);
        // }
        this.created = params.created || 0;
    }

    get isCloud() {
        return this._isCloud;
    }

    setToCloud() {
        this._isCloud = true;
    }

    public get title(): string {
        if (this.coords.project$.currentId === this.id) return this.coords.project$.currentTitle;
        return this._title;
    }

    public set title(value: string) {
        value = value.trim();
        if (this._title === value) return;
        this._title = value;
        if (this.isCloud) this._updateCloud();
    }

    async setHost(hostId: string, created: number) {
        console.log('sethost', hostId, created);
        try {
            const c = Temporal.Instant.fromEpochSeconds(Math.floor(created / 1000));
            const timeZone = Temporal.TimeZone.from('GMT');
            this._invitationData = {
                hostId: hostId,
                created: c.toZonedDateTimeISO(timeZone),
            };
        } catch (e) {
            this.coords.utils$.consoleError('SET HOST PROJECT IN LIST', e);
        }
    }

    get host() {
        if (!this._invitationData) return null;
        return {
            created: this._invitationData.created,
            host: this.coords.user$.get(this._invitationData.hostId),
        };
    }

    private async _updateCloud() {
        if (this.id !== this.coords.project$.currentId) return;
        const fs = this.coords.firebase$.firestore;
        const resp = await this.coords.firebase$.firestore.updateDocument('projects', this.id, {
            data: fs.addTimestampField({
                title: this.coords.project$.title,
                // description: this.coords.project$.current?.get("description")
            }),
        });
    }

    private _finalizeDateTime(params: any) {
        try {
            let instant: Temporal.Instant;
            if (params.timestamp) {
                instant = Temporal.Instant.fromEpochSeconds(params.timestamp.seconds);
            } else if (params.lastOpen) {
                instant = Temporal.Instant.from(params.lastOpen);
            } else throw new Error();

            this.lastOpen = instant.toZonedDateTimeISO('UTC');
        } catch (e) {
            this.lastOpen = this.coords.utils$.zonedDateTimeFromNumber(0);
        }

        this.coords.display$.markForCheck();
    }

    private get _cloudUserDetailID() {
        return `${this.coords.user$.currentId}|${this.id}`;
    }

    async finalizeFromCloud() {
        try {
            const resp = await this.coords.firebase$.firestore.getObject('projects', this.id);
            if (!resp) return;

            const resp2 = await this.coords.firebase$.firestore.getObject(
                'projectUserDetails',
                this._cloudUserDetailID,
            );

            this._finalizeDateTime(resp2);
            // console.log('FINALIZE PROJECT FROM CLOUD', resp, resp['data']);
            this._title = resp['data']['title'];
            const tagLs = resp['data']['tagLs'];
            if (tagLs) this.tagLs = tagLs;
            this.coords.project$.setProjectInList(this);
        } catch (e) {
            console.error('PIL finalizeFromCloud ERROR', e);
        }
    }

    search(txt: string) {
        let str = this.tagLs.join('$$$');
        str += '$$$' + this.title;
        str = str.toLowerCase();
        return str.includes(txt.toLowerCase());
    }
    async select() {
        const p$ = this.coords.project$;

        this.coords.manifest$.post('log-open-project', {
            projectId: this.id,
            title: this.title,
            isCloud: this.isCloud,
        });

        this.coords.display$.dialog$.next({
            action: 'open-project-in-progress',
        });
        p$.isDisplayOn = false;
        p$.isLoading = true;

        let i = 0;
        while (this.coords.hasInProgressActions) {
            console.log('WAITING - in progress action', i);
            await this.coords.utils$.wait(2);
            if (i++ > 50) break;
        }

        await p$.clear();

        if (this.isCloud) {
            let piamResult = await this.coords.project$.runPiam(this.id);
            if (this.role !== 'owner') {
                let i = 0;
                while (!piamResult) {
                    console.log('WAITING - piam', i);
                    await this.coords.utils$.wait(0.5);
                    piamResult = await this.coords.project$.runPiam(this.id);
                    if (i++ > 10) {
                        alert(
                            'Unable to get user permisssions. Please contact the project owner or try again later.',
                        );
                        return;
                    }
                }
            }

            await p$.loadCloudProject(this.id);
            await this.cloudOpenUpdate();
        } else await p$.loadLocalProject(this.id);

        this.coords.appChannelPost({
            action: 'open',
            id: this.id,
        });

        if (this.isFirstRun) {
            setTimeout(() => {
                this.coords.search$.initNewProject();
                this.isFirstRun = false;
            }, 1000);
        }
    }

    get icon() {
        let tag: string;

        if (this.isCloud) {
            tag = 'cloud';
        } else {
            tag = 'local';
        }
        return this.coords.icon(tag);
    }

    async localOpenUpdate() {
        this.lastOpen = this.coords.utils$.zonedDateTimeNow;

        const stmp = this.lastOpen.toInstant().toString();

        // const r = await navigator.storage.getDirectory();
        // const pH = await r.getDirectoryHandle(this.id);
        // const loH = await pH.getFileHandle('.last-open', { create: true });
        await this.coords.utils$.writeToDisk(`/${this.id}/.last-open`, stmp);
    }

    async cloudOpenUpdate() {
        const subText = 'projectUserDetails';

        this.lastOpen = this.coords.utils$.zonedDateTimeNow;

        await this.coords.user$.closeQuerySubscription(subText);
        const fs = this.coords.firebase$.firestore;
        await fs.addDocument(
            subText,
            this._cloudUserDetailID,
            fs.addTimestampField({
                userId: this.coords.user$.currentId,
                instanceId: this.coords.instanceId,
            }),
        );

        const uns = await this.coords.firebase$.firestore.subscribeObject(
            subText,
            this._cloudUserDetailID,
            async (x: any) => {
                const d = x.data();
                if (d.instanceId !== this.coords.instanceId) {
                    console.log('OTHER INSTANCE HAS THIS PROJECT');
                    await this.coords.project$.current?.terminate();
                    await this.coords.project$.clear();
                    this.coords.display$.dialog$.next({ action: 'start' });
                }
            },
        );

        uns && this.coords.user$.addQuerySubscription(subText, uns);
    }

    get printModified() {
        return this.coords.utils$.citeDate(this.lastOpen!, {
            withTime: true,
            noFormat: true,
        });
    }

    delete() {
        if (!this.coords.acl$.isOn('project', 'delete', this.role)) return;
        if (this.isCloud) {
            this._deleteCloudProject();
        } else {
            this.coords.manifest$.post('delete-project', { projectId: this.id });
            this.coords.project$.unsetProjectInList(this);
        }
    }

    async leave() {
        // this._deleteCloudProject(true)
        const storageParamsLs: QF[] = [
            {
                field: 'projectId',
                value: this.id,
            },
            {
                field: 'userId',
                value: this.coords.user$.currentId,
            },
        ];

        const lsStorage = await this.coords.firebase$.firestore.getObjectLs(
            'storage',
            storageParamsLs,
        );
        for (const x of lsStorage) {
            await this.coords.firebase$.storage.deleteFile(x.remotePath);
        }
        const lsRef = await this.coords.firebase$.firestore.getRefLs('storage', storageParamsLs);
        await this.coords.firebase$.firestore.deleteDocumentLs(lsRef);
        const resp = await this.coords.firebase$.firestore.deleteDocument(
            'teams',
            `${this.coords.user$.currentId}|${this.id}`,
        );
        this.coords.project$.unsetProjectInList(this);
    }

    clearCache() {
        this.isCloud && this.coords.manifest$.post('delete-project', { projectId: this.id });
    }

    async acceptInvitation() {
        this.coords.user$.cloudTeamManager?.acceptInvitation(this);
    }

    async rejectInvitation() {
        this.coords.user$.cloudTeamManager?.rejectInvitation(this);
    }

    private async _deleteCloudProjectStorageFiles() {
        const fs = this.coords.firebase$.firestore;
        const qs = await fs.getDocLs('storage', [
            {
                field: 'projectId',
                value: this.id,
            },
            {
                field: 'userId',
                value: this.coords.user$.currentId,
            },
        ]);

        const refLs: DocumentReference[] = [];
        const dLs: any[] = [];
        qs.forEach((doc) => {
            refLs.push(doc.ref);
            dLs.push(this.coords.firebase$.storage.deleteFile(doc.data()['remotePath']));
        });
        await Promise.all(dLs);
        const resp = await fs.deleteDocumentLs(refLs);
        return resp;
    }

    private async _deleteCloudProject() {
        const resp = await this.coords.firebase$.callFunction('deleteCloudProject', {
            projectId: this.id,
        });

        if (resp !== 'ERROR' && (resp as any).isSuccess) {
            this.coords.manifest$.post('delete-project', { projectId: this.id });
            this.coords.project$.unsetProjectInList(this);
        }
    }

    get lastOpenText() {
        if (!this.lastOpen) return '';
        const dtz = this.lastOpen!.toInstant().toZonedDateTimeISO(
            Intl.DateTimeFormat().resolvedOptions().timeZone,
        );
        return this.coords.utils$.citeDate(dtz, { noFormat: true, withTime: true });
    }

    get message() {
        const ls: any[] = [];
        ls.push({ text: this.title });

        if (this.isCloud) {
            ls.push({ text: this.coords.project$.current?.team?.message });
        } else
            ls.push({
                text: this.coords.text('loadingProjectData'),
            });
        return ls;
    }
}
